
    var nlsModule = require("/home/runner/work/web/web/static/nls/code-evaluator.js");
    var value = nlsModule.default ? nlsModule.default : {};
    var generateTranslation = require("js/lib/_t").default;
    var translate = generateTranslation(value);
    translate.getLocale = function() { return "__WEBPACK_MULTI_OUTPUT_VALUE__"; };
    module.exports = translate;
  